__turbopack_context__.v({
  "answer": "jbF2HW_answer",
  "resources": "jbF2HW_resources",
  "richTextContent": "jbF2HW_richTextContent",
  "title": "jbF2HW_title",
});
